import PropTypes from 'prop-types';
import { ChangeHistory } from '@/components/global/history/ChangeHistory.jsx';

const formatCollectionPointFieldLabel = (field, translate) => {
    const leaf = String(field).split('.').pop();
    const dayMatch = /^(mon|tue|wed|thu|fri|sat|sun)(From|To|Closed)$/.exec(leaf);

    if (!dayMatch) {
        return null;
    }

    const day = translate(`resources.collectionPoint.days.${dayMatch[1]}`);
    const part = translate(`resources.collectionPoint.history.dayParts.${dayMatch[2].toLowerCase()}`);

    return `${day} ${part}`;
};

export const CollectionPointHistory = ({ collectionPointId }) => (
    <ChangeHistory
        resource='collection-point'
        recordId={collectionPointId}
        fieldsSource='resources.collectionPoint.fields'
        formatFieldLabel={formatCollectionPointFieldLabel}
    />
);

CollectionPointHistory.propTypes = {
    collectionPointId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
